import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
import { computed } from '../../adapter-vue';
import TUIChatEngine, { TUIStore } from '@tencentcloud/chat-uikit-engine';
import { isCustomerServicePluginMessage, isCustomServiceMessageInvisible } from './message-customer/index';
import { isCallMessage, isRoomCardMessage } from './index';
import MessagePluginLayout from './message-plugin-layout.vue';
import MessageCallGroup from './message-call/message-call-group.vue';
import MessageCallC2C from './message-call/message-call-c2c.vue';
import MessageCustomerService from './message-customer/message-customer-service.vue';
// 未集成 TUIRoom 时，请引入以下路径
import MessageRoom from './message-room/message-room-default.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-plugin',
  props: {
    message: {
      default: () => ({})
    },
    blinkMessageIDList: {
      default: () => []
    }
  },
  emits: ['resendMessage', 'handleToggleMessageItem', 'handleH5LongPress'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var messageModel = computed(() => TUIStore.getMessageModel(props.message.ID));
    var messageSignalingInfo = computed(() => {
      var _messageModel$value;
      return messageModel === null || messageModel === void 0 || (_messageModel$value = messageModel.value) === null || _messageModel$value === void 0 ? void 0 : _messageModel$value.getSignalingInfo();
    });
    var messageCustomContent = computed(() => {
      var _messageModel$value2;
      return messageModel === null || messageModel === void 0 || (_messageModel$value2 = messageModel.value) === null || _messageModel$value2 === void 0 ? void 0 : _messageModel$value2.getMessageContent();
    });
    // 需要展示 ui 的判断逻辑
    var pluginMessageType = computed(() => {
      var typeObj = {
        pluginType: '',
        showStyle: ''
      };
      if (isCallMessage(messageModel.value)) {
        var _messageModel$value3;
        typeObj = {
          pluginType: 'call',
          showStyle: ((_messageModel$value3 = messageModel.value) === null || _messageModel$value3 === void 0 ? void 0 : _messageModel$value3.conversationType) === TUIChatEngine.TYPES.CONV_GROUP ? 'tip' : 'bubble'
        };
      } else if (isRoomCardMessage(messageModel.value)) {
        typeObj = {
          pluginType: 'room',
          showStyle: 'bubble'
        };
      } else if (isCustomerServicePluginMessage(messageModel.value)) {
        typeObj = {
          pluginType: 'customer',
          showStyle: isCustomServiceMessageInvisible(messageModel.value) ? '' : 'bubble'
        };
      }
      return typeObj;
    });
    // 以下为messageTool等外部交互使用，无需特殊处理，勿动
    var resendMessage = message => {
      emits('resendMessage', message);
    };
    var handleToggleMessageItem = function handleToggleMessageItem(e, message) {
      var isLongpress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      emits('handleToggleMessageItem', e, message, isLongpress);
    };
    var handleH5LongPress = (e, message, type) => {
      emits('handleH5LongPress', e, message, type);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(MessagePluginLayout, {
        message: props.message,
        showStyle: _unref(pluginMessageType).showStyle,
        bubbleClassNameList: [_unref(pluginMessageType).pluginType === 'room' ? 'message-bubble-room' : ''],
        onResendMessage: resendMessage,
        onHandleToggleMessageItem: handleToggleMessageItem,
        onHandleH5LongPress: handleH5LongPress
      }, {
        messageTip: _withCtx(() => [_createVNode(MessageCallGroup, {
          message: props.message,
          signalingInfo: _unref(messageSignalingInfo),
          customContent: _unref(messageCustomContent),
          blinkMessageIDList: props.blinkMessageIDList
        }, null, 8, ["message", "signalingInfo", "customContent", "blinkMessageIDList"])]),
        messageBubble: _withCtx(() => [_unref(pluginMessageType).pluginType === 'call' ? (_openBlock(), _createBlock(MessageCallC2C, {
          key: 0,
          message: props.message,
          signalingInfo: _unref(messageSignalingInfo),
          customContent: _unref(messageCustomContent)
        }, null, 8, ["message", "signalingInfo", "customContent"])) : _createCommentVNode("", true), _unref(pluginMessageType).pluginType === 'customer' ? (_openBlock(), _createBlock(MessageCustomerService, {
          key: 1,
          message: props.message
        }, null, 8, ["message"])) : _createCommentVNode("", true), _unref(pluginMessageType).pluginType === 'room' ? (_openBlock(), _createBlock(MessageRoom, {
          key: 2,
          message: props.message
        }, null, 8, ["message"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["message", "showStyle", "bubbleClassNameList"]);
    };
  }
});